/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { BlockText } from "frontend/src/components/BlockText"
import Img from "gatsby-image"
import { getFluidFromAsset } from "frontend/src/utils/gatsbyImageHelpers"
import { Flex, SectionGrid } from "frontend/src/components/Layout"

function BlockTextWithImage({ content, image, imagePosition }) {
  return (
    <SectionGrid>
      <SectionGrid.narrow sx={{ paddingTop: "70px" }}>
        <Flex direction={imagePosition === "left" ? "row" : "row-reverse"} wrap sx={{ flex: 1 }}>
          <div sx={{ minWidth: 220, flex: 1 }}>
            <Img
              fluid={getFluidFromAsset(image, 600)}
              sx={{
                position: "relative",
                width: imagePosition === "left" ? "100%" : "100%",
                pb: "100%",
                height: 0,
                objectFit: "cover",
                ml: imagePosition === "left" ? [5, 0, 0] : [5, 0, 0],
                mr: imagePosition === "left" ? [5, 0, 0] : [5, 0, 0],
                mt: [0, 5],
              }}
            />
          </div>
          <div
            sx={{
              minWidth: 250,
              flex: 1,
              pt: 8,
              ml: imagePosition === "left" ? [5, 5, 7] : [5, 5, 0],
              mr: imagePosition === "left" ? [5, 5, 0] : [0, 5, 7],
            }}
          >
            <BlockText blocks={content} />
          </div>
        </Flex>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { BlockTextWithImage }
